<div class="wxt-bar">
  <!-- Header -->
  <div class="wxt-header">
    <span class="wxt-title">Forecast<ng-container *ngIf="currentLabel"> (<span class="wxt-current-label"><span *ngIf="selectedDate">{{ selectedDate + 'T00:00:00Z' | date:'EEE d MMM':'UTC' }} &middot; </span>{{ currentLabel }}</span>)</ng-container></span>
    <span class="wxt-freq" *ngIf="updateFrequency">Every {{ updateFrequency }}</span>
  </div>

  <!-- Body -->
  <div class="wxt-body">
    <!-- Time slider -->
    <div class="wxt-slider-section" *ngIf="timeSlots.length">
      <div class="wxt-track-row">

        <!-- Prev step button -->
        <button type="button" class="wxt-step-btn"
          [disabled]="sliderPosition === 0"
          (click)="onPrevStep()"
          aria-label="Previous time step">&#8249;</button>

        <!-- Track + floating label + tick row -->
        <div class="wxt-track-wrap">
          <div class="wxt-thumb-label" [style.left.%]="thumbLeftPercent">{{ currentLabel }}</div>

          <input
            type="range"
            class="wxt-range"
            aria-label="Forecast time"
            min="0"
            [max]="maxPosition"
            step="1"
            [value]="sliderPosition"
            [style.background]="trackBackground"
            (input)="onSliderChange($event)">

          <div class="wxt-ticks" [class.wxt-ticks--windowed]="useWindow">
            <span
              class="wxt-tick"
              *ngFor="let t of visibleTicks; trackBy: trackByLabel"
              [style.left.%]="t.leftPercent">{{ t.label }}</span>
          </div>
        </div>

        <!-- Next step button -->
        <button type="button" class="wxt-step-btn"
          [disabled]="sliderPosition === maxPosition"
          (click)="onNextStep()"
          aria-label="Next time step">&#8250;</button>

      </div>
    </div>

    <!-- Day strip -->
    <div class="wxt-days">
      <button type="button" class="wxt-day" *ngFor="let d of visibleDates"
        [class.active]="d === selectedDate" (click)="onSelectDate(d)">
        <span class="wxt-day-week">{{ d + 'T00:00:00Z' | date:'EEE':'UTC' }}</span>
        <span class="wxt-day-num">{{ d + 'T00:00:00Z' | date:'d MMM':'UTC' }}</span>
      </button>
    </div>
  </div>
</div>
